import classNames from 'classnames';
import { useState } from 'react';
import styles from './LanguageSelector.module.scss';
import { LanguageSelectorItem } from './LanguageSelectorItem/LanguageSelectorItem';

export interface LanguageSelectorProps {
	listLinkItems: React.ReactElement[];
	padded?: boolean;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ listLinkItems, padded }) => {
	const [showLanguages, setShowLanguages] = useState(false);

	const toggleLanguagesHandler = (event) => {
		if (!(event.key === 'Enter'|| event.key === undefined)) return;
		if (showLanguages) setShowLanguages(false);
		else setShowLanguages(true);
	}

	return (
		<div className={classNames(
				styles.LanguageSelector, 
				padded && styles.LanguageSelector___padded, {
				['u-languageSelector-ipad'] : listLinkItems.length > 5 && true,
			})}>
			<div className={styles.LanguageSelector_wrapper} tabIndex={0} onClick={toggleLanguagesHandler} onKeyUp={toggleLanguagesHandler}>
				<LanguageSelectorItem globe />
				<span className={classNames(styles.LanguageSelector_mobile, { 
						[styles.LanguageSelector_ipad] : listLinkItems.length > 5 && true,
						[styles.LanguageSelector_mobile___open] : showLanguages,
					})}>
					{listLinkItems[0]}
				</span>
				<ul className={classNames(styles.LanguageSelector_list, {
						[styles.LanguageSelector_mobileList] : showLanguages,
						[styles.LanguageSelector_ipadList] : listLinkItems.length > 5,
						[styles.LanguageSelector_ipadList___show] : listLinkItems.length > 5 && showLanguages,
					})}>
					{listLinkItems}
				</ul>
			</div>
		</div>
	);
};
